import React from "react";
import { CurrentUserContext, CurrentUserContextConsumer } from "../contexts/current_user_context.js";

/**
 * Provide info about current signed in user and methods for fetch and sign out
 * @component
 * @category HOC
 * @param providedProps
 * @param {object} providedProps.currentUser - Current logged in user (can be undefined)
 * @param {object} providedProps.adminDashboardAbilityInfo - Ability info for admin (can be undefined)
 * @param {boolean} providedProps.userOnceLoaded - Request for load current user was called
 * @param {object} providedProps.abilityInfos - Info about user abilities (can be undefined)
 * @param {func} providedProps.loadUser - Function for loading info about current logged in user
 * @param {func} providedProps.signOut - Function for sign out
 * 
 */
const WithCurrentUser = (Component) => {

  class WithCurrentUser extends React.Component {



    render() {
      return (
        <CurrentUserContextConsumer>
          { context => 
            <Component { ...this.props } 
                       currentUser = { context.currentUser }
                       adminDashboardAbilityInfo = { context.adminDashboardAbilityInfo }
                       userOnceLoaded = { context.userOnceLoaded }
                       abilityInfos = { context.abilityInfos }
                       menus = { context.menus }
                       loadUser = { context.loadUser }
                       signOut = { context.signOut } />
          }
        </CurrentUserContextConsumer>
      )
    }
  }

  WithCurrentUser.contextType = CurrentUserContext;

  return WithCurrentUser;
};

export default WithCurrentUser;